import { Children, cloneElement, isValidElement, useState } from "react";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { ExpandingTooltip } from "../tooltips/ExpandingTooltip";
import { ModelViewDropdown } from "./ModelViewDropdown";
import { TooltipPanel, TooltipPanelProps } from "./TooltipPanel";

export {
  ModelConfigurationViewToolTipPanel,
  ModelConfigurationViewToolTipPanel2,
};

type Props = {
  dropdownTooltipText: ExpandingTooltip;
} & TooltipPanelProps;

type View = "extraction" | "transformation" | "validation";
const ModelConfigurationViewToolTipPanel = (props: Props) => {
  const [view, setView] = useState<View>("extraction");

  const children = Children.map(props.children, (child) => {
    if (!isValidElement<{ view: View }>(child)) return child;

    return cloneElement(child, {
      view,
    });
  });

  return (
    <TooltipPanel
      {...props}
      headerChildren={
        <AdvancedTooltip overflow tooltipText={props.dropdownTooltipText}>
          {(tProps) => (
            <ModelViewDropdown tProps={tProps} view={view} onChange={setView} />
          )}
        </AdvancedTooltip>
      }
    >
      {children}
    </TooltipPanel>
  );
};
const ModelConfigurationViewToolTipPanel2 = (
  props: Omit<Props, "children"> & {
    children: (view: View) => React.ReactElement;
  },
) => {
  const [view, setView] = useState<View>("extraction");

  return (
    <TooltipPanel
      {...props}
      headerChildren={
        <AdvancedTooltip overflow tooltipText={props.dropdownTooltipText}>
          {(tProps) => (
            <ModelViewDropdown tProps={tProps} view={view} onChange={setView} />
          )}
        </AdvancedTooltip>
      }
    >
      {props.children(view)}
    </TooltipPanel>
  );
};
